import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import type { CommentAddEditAction } from '../../types';
import { patchContentObjectCommentsCount } from '../../utils';
import { getContentObjectRepliesQueryKey } from '../keys';
import type { GetContentObjectRepliesQuery } from '../use-content-object-replies-query';

/**
 * @deprecated Introduced as part of the #87353 feed refactor to manually patch the React Query cache
 * after each mutation. This ad-hoc cache-patching approach needs a better long-term solution.
 */
export const useAddComment = () => {
  const queryClient = useQueryClient();

  return useCallback(
    ({ contentObjectId, reply }: CommentAddEditAction) => {
      queryClient.setQueriesData<GetContentObjectRepliesQuery>(
        { queryKey: getContentObjectRepliesQueryKey({ id: contentObjectId }) },
        (replies) => {
          if (!replies) {
            return [reply];
          }
          const newReplies = [...replies];
          const parentReply = newReplies.find((r) => r.id === reply.parentId);

          if (parentReply) {
            const updatedParentReply = {
              ...parentReply,
              replies: [...(parentReply.replies ?? []), reply],
            };
            const parentReplyIndex = newReplies.findIndex((r) => r.id === reply.parentId);

            newReplies[parentReplyIndex] = updatedParentReply;
          } else {
            newReplies.push(reply);
          }

          return newReplies;
        },
      );

      patchContentObjectCommentsCount({ delta: 1, id: contentObjectId, queryClient });
    },
    [queryClient],
  );
};
